module.exports = __webpack_public_path__ + "img/info_icon.c42133f3.svg";